var WDN = WDN || {};

/* Code for search modal */
if (typeof WDN.Search === "undefined") {
  WDN.Search = (function () {
    // CONFIGURATION
    // <::> Didnt really do anything...
    var config = {
      history: {
        key: "searchHistory",
        limit: 5,
      },
      search: {
        minQueryLength: 1,
        debounceInputBy: 20,
      },
      suggestions: {
        maxStorageLength: 100,
        maxResults: 8, // + 1 at the end
      },
    };

    // History module
    var History = {
      read: function () {
        var storage = localStorage.getItem(config.history.key);
        if (!storage) return [];
        return JSON.parse(storage);
      },
      push: function (query) {
        if (typeof query === "undefined") return;

        // Read storage
        var storage = this.read();

        // Loop through storage to filter out duplicate results
        storage.forEach(function (item, i) {
          if (item !== query) return;
          // Remove item from history
          storage.splice(i, 1);
        });

        // Push query to beginning of the list
        storage.unshift(query);

        // Check if storage limit reached
        if (storage.length > config.history.limit) {
          // Remove extra items from the list
          storage = storage.slice(0, config.history.limit);
        }

        // Push to localstorage
        localStorage.setItem(config.history.key, JSON.stringify(storage));
      },
      clear: function () {
        localStorage.removeItem(config.history.key);
      },
      getTemplateClone: function () {
        var template = document.querySelector("[data-search-template='history']");
        return template.content.cloneNode(true);
      },
      getRenderableList: function () {
        var list = [];
        var storage = this.read();
        if (storage.length === 0) return [];

        // <::> Why iterate everything, instead of capping it?
        var storageCapped = storage.slice(0, config.history.limit);

        storageCapped.forEach(function (item) {
          var templateClone = this.getTemplateClone();
          var cloneLink = templateClone.querySelector("a");
          var cloneLabel = templateClone.querySelector("[data-history-label]");

          // Setup link href
          cloneLink.href = cloneLink.href + encodeURIComponent(item);

          // Setup link name
          cloneLabel.innerHTML = item;

          list.push(templateClone);
        }, this);

        return list;
      },
    };

    var Suggestions = {
      read: function () {
        return WDN.SQRList || [];
      },
      match: function (query) {
        if (typeof query === "undefined") return [];

        var list = this.read();
        var output = [];

        // Will contain suggestions that begin with the query
        var completeMatch = [];
        // Will contain suggestions that contain query
        var partialMatches = [];

        for (var i = 0; i < list.length; i++) {
          var suggestion = list[i];
          var queryIndex = suggestion.toLowerCase().indexOf(query.toLowerCase());
          var foundMatches = completeMatch.length + partialMatches.length;

          // If reached maximum number of matches
          if (foundMatches >= config.suggestions.maxStorageLength) break;

          // If query not found in suggestion
          if (queryIndex === -1) continue;

          // Handle suggestion beginning with query
          if (queryIndex === 0) {
            completeMatch.push(suggestion);
            continue;
          }

          // Handle queryIndex > 0
          partialMatches.push(suggestion);
        }

        // Merge two arrays into one
        output = [...completeMatch, ...partialMatches];

        // Remove extra results
        output = output.slice(0, config.suggestions.maxResults);

        // Output
        return output;
      },
      getRenderableList: function (query) {
        var suggestions = this.match(query);
        var searchModule = document.querySelector("search-element");
        // Get full query, since passed query can be only one word
        // input: "svømmebriller til hund"
        // If no suggestions found for this query, first word will be used "svømmebriller"
        // This is the reason why we run readQuery() instead of using passed query param
        var searchModuleQuery = searchModule.readQuery();

        var output = [];

        // Loop through each suggestion
        suggestions.forEach(function (suggestion, i) {
          // Get clone
          var templateClone = this.getTemplateClone();
          // Select nodes
          var customElement = templateClone.querySelector("search-query-recommendation");
          var cloneLink = customElement.querySelector("a");
          var cloneLabel = customElement.querySelector("[data-suggestion-label]");
          // Encode suggestion so it is ready to be appended to the URL
          var encodedSuggestion = encodeURIComponent(suggestion);

          // Set attribute which will be read by custom element
          customElement.setAttribute("data-query", suggestion);
          customElement.setAttribute("data-index", i);

          // Initial state
          var text = false;

          // Split query sentance into words
          searchModuleQuery.split(" ").forEach(function (word) {
            /*
          suggestion: "Medalje holdere til svømning"

          regex => written so it finds Medalje, medalje, MeDaLje etc,

          suggestion.replace => Replaces any regex key with match item
          
          regex: Regular expression pattern with word boundaries (\b) and case-insensitive (i) flags        
          */
            // ')' and '(' cause problems with regex
            var word = word.replaceAll("(", "").replaceAll(")", "");
            var regex = new RegExp(`\\b${word}`, "gi");
            var regexMatch = suggestion.match(regex);

            if (!regexMatch) return;
            // badesko børn => ["b", "b"] => merge into ["b"]
            var uniqueMatch = [...new Set(regexMatch)];

            uniqueMatch.forEach(function (match, i) {
              if (text) {
                text = text.replaceAll(match, `[${match}]`);
              } else {
                text = suggestion.replaceAll(match, `[${match}]`);
              }
            });
          });

          if (!text) return;

          // Setup link href
          cloneLink.href = cloneLink.href + encodedSuggestion;

          // Setup link label
          cloneLabel.innerHTML = text.replaceAll("[", "<strong>").replaceAll("]", "</strong>");

          // Push
          output.push(templateClone);
        }, this);

        // Handle last suggestion

        var lastSuggestionClone = this.getLastSuggestionTemplateClone();
        var lastSuggestion = lastSuggestionClone.querySelector("search-query-recommendation");
        var lastSuggestionLabel = lastSuggestion.querySelector("[data-suggestion-label]");
        var lastSuggestionLink = lastSuggestion.querySelector("a");

        // By default use whole word - Søg

        lastSuggestionAttribute = "letter";
        // If query longer than 4 - Søg på hele Watery.dk
        if (query.length > 6) {
          var lastSuggestionAttribute = "word";
        }

        lastSuggestion.setAttribute("data-query", query);
        lastSuggestion.setAttribute("data-index", 8);

        lastSuggestionLabel.innerHTML = query;
        lastSuggestionLink.href = lastSuggestionLink.href + encodeURIComponent(query);
        lastSuggestion.setAttribute("data-query-type", lastSuggestionAttribute);

        output.push(lastSuggestionClone);

        return output;
      },
      getTemplateClone: function () {
        var template = document.querySelector("[data-search-template='suggestion']");
        return template.content.cloneNode(true);
      },
      getLastSuggestionTemplateClone: function () {
        var template = document.querySelector("[data-search-template='suggestion-last']");
        return template.content.cloneNode(true);
      },
    };

    class Search extends HTMLElement {
      constructor() {
        super();
      }

      assignNodes() {
        this.nodes = {
          form: this.querySelector("form"),
          input: this.querySelector("[data-search-input]"),
          history: this.querySelector("[data-search-container='history']"),
          clearHistory: this.querySelector('[data-search-clear="history"]'),
          suggestions: this.querySelector("[data-search-container='suggestions']"),
          products: this.querySelector("[data-search-container='products']"),
          articles: this.querySelector("[data-search-container='articles']"),
          queryContainer: this.querySelector("[data-search-modal-query]"),
        };
      }

      setInputState(newState) {
        if (!newState) return;
        this.setAttribute("data-input-state", newState);
      }

      setModalState(newState) {
        if (!newState) return;
        this.setAttribute("data-modal-state", newState);
      }

      setQuery(newQuery) {
        if (typeof newQuery === "undefined") return;
        this.nodes.input.value = newQuery;

        this.setModalState("default");

        // Send request
        this.search();
      }

      readQuery() {
        return this.nodes.input.value.trim();
      }

      renderHistory() {
        var history = History.read();

        // Append history count to the container
        this.setAttribute("data-history-count", history.length);

        // Empty container
        this.nodes.history.innerHTML = "";

        // if history blank - stop
        if (history.length === 0) return;

        // Get renderable list
        var outputList = History.getRenderableList();

        // Loop through it and append it to the container
        outputList.forEach(function (item) {
          this.nodes.history.appendChild(item);
        }, this);
      }

      onSearchError() {}

      renderQuerySuggestions() {
        var query = this.readQuery();
        var suggestions = [];

        // If query is not blank - get suggestions
        if (query !== "") {
          suggestions = Suggestions.getRenderableList(query);
        }

        // If no suggestions found
        if (suggestions.length === 0) {
          // Get first word from the query
          var firstWord = query.split(" ")[0];

          // If first word exists and is not as same as query
          if (firstWord && firstWord !== query) {
            suggestions = Suggestions.getRenderableList(firstWord);
          }
        }

        // Configure - See Alle produkter on mobile
        var mobileSeeAll = document.querySelectorAll("[data-search-sqr-all-products] a");

        mobileSeeAll.forEach(function (link) {
          link.href = Shopify.routes.root + "search?q=" + this.readQuery() + "&type=product";
        }, this);

        // Set attribute
        this.setAttribute("data-suggestions-count", suggestions.length);

        // Empty container
        this.nodes.suggestions.innerHTML = "";

        // Output
        suggestions.forEach(function (suggestion) {
          this.nodes.suggestions.appendChild(suggestion);
        }, this);
      }

      onProductSearchSuccess(res) {
        var domParser = new DOMParser();
        var parsedResponse = domParser.parseFromString(res, "text/html");

        // Output query (for eg. No results text)
        if (this.nodes.queryContainer) this.nodes.queryContainer.innerHTML = this.readQuery();

        var productWrapper = parsedResponse.querySelector("[data-search-product-count]");
        // Store Product count
        this.foundProductCount = parseInt(productWrapper.getAttribute("data-search-product-count"));
        // Set count attribute
        this.setAttribute("data-product-count", this.foundProductCount);

        // Inject into DOM
        this.nodes.products.innerHTML = res;

        // Output count (for mobile tab)
        document.querySelectorAll("[data-search-product-result-count]").forEach(function (container) {
          container.innerHTML = this.foundProductCount;
        }, this);

        // Configure - See Alle produkter on mobile
        var mobileSeeAll = document.querySelectorAll("[data-search-sqr-all-products] a");

        mobileSeeAll.forEach(function (link) {
          link.href = Shopify.routes.root + "search?q=" + this.readQuery() + "&type=product";
        }, this);

        // Dispatch Event
        this.dispatchEvent(
          new CustomEvent("search:updated", {
            detail: {},
          })
        );

        // Handle Both Product & Article request done
        if (this.articleRequest.readyState === 4) {
          this.setModalState("has-search");
        }
      }

      onArticleSearchSuccess(res) {
        var domParser = new DOMParser();
        var parsedArticleResponse = domParser.parseFromString(res, "text/html");

        // Nodes
        var articleWrapper = parsedArticleResponse.querySelector(".search__articles");

        // Store Article count
        this.foundArticleCount = articleWrapper.querySelectorAll(".search__article").length;

        // Set count attribute
        this.setAttribute("data-article-count", this.foundArticleCount);

        // Inject into DOM
        this.nodes.articles.innerHTML = "";
        this.nodes.articles.appendChild(articleWrapper);

        // Dispatch Event
        this.dispatchEvent(
          new CustomEvent("search:updated", {
            detail: {},
          })
        );

        // Handle Both article + Product request done
        if (this.productRequest.readyState === 4) {
          this.setModalState("has-search");
        }
      }

      search() {
        // If product request not complete - abort
        if (this.productRequest && this.productRequest.readyState !== 4) {
          this.productRequest.abort();
        }
        // If article request not complete - abort
        if (this.articleRequest && this.articleRequest.readyState !== 4) {
          this.articleRequest.abort();
        }

        // Store query
        var query = this.readQuery();

        // Get query suggestions
        this.renderQuerySuggestions();

        var searchParams = new URLSearchParams();
        // General Search params - shared between products and articles/pages
        searchParams.set("q", query);
        searchParams.set("view", "modal");

        // Search params - product specific
        searchParams.set("type", "product");

        // Search for products - Mobile (18 results)
        if (window.innerWidth < 900) {
          searchParams.set("view", "modal_products");
        }

        // Search for products
        this.productRequest = WDN.Request.Get({
          url: Shopify.routes.root + "search?" + searchParams.toString(),
          onSuccess: this.onProductSearchSuccess.bind(this),
          onError: this.onSearchError.bind(this),
        });

        // Search params - article/page specific
        searchParams.delete("page");
        searchParams.set("type", "article,page");
        searchParams.set("view", "modal");

        /* Search for pages and articles */
        this.articleRequest = WDN.Request.Get({
          url: Shopify.routes.root + "search?" + searchParams.toString(),
          onSuccess: this.onArticleSearchSuccess.bind(this),
          onError: this.onSearchError.bind(this),
        });
      }

      formOnSubmit(e) {
        e.preventDefault();
        var query = this.readQuery();

        // If value is blank - stop
        if (query === "") return;

        // Push query to history
        History.push(query);

        var baseURL = "https://" + window.location.host + Shopify.routes.root + "search";

        // Go to URL
        window.location.href = baseURL + "?q=" + encodeURIComponent(query) + "&type=product";
      }

      inputOnKeyUp() {
        // Read query
        var query = this.readQuery();

        // If query is the same as the last one - skip
        if (query === this.lastQuery) return;

        // Store last query
        this.lastQuery = query;

        // Render query suggestions - automatically handles blank query
        this.renderQuerySuggestions();

        // If query is blank - stop
        if (query === "") {
          this.setInputState("default");
          this.setModalState("default");
          // Cancel current request
          if (this.productRequest && this.productRequest.readyState !== 4) {
            this.productRequest.abort();
          }
          if (this.articleRequest && this.articleRequest.readyState !== 4) {
            this.articleRequest.abort();
          }
          // Set phone stage to SQR
          this.parentNode.setAttribute("data-search-phone-stage", "sqr");
          return;
        }

        // If query length less than minimum - stop
        if (query.length < config.minQueryLength) return;

        // Update input state
        this.setInputState("has-search");

        // Send request
        this.search();
      }

      // Handles focus event
      inputOnFocus() {
        this.setInputState("focused");
      }

      // Handles focusout event
      inputOnFocusout() {
        var query = this.readQuery();
        var newState = "default";

        if (query.length > 0) {
          newState = "has-search";
        }

        this.setInputState(newState);
      }

      // Handles clearing history
      clearHistoryOnClick(e) {
        e.preventDefault();
        History.clear();
        this.renderHistory();
      }

      listenForEvents() {
        // Debounced functions
        this.inputOnKeyUpDebounced = WDN.Debounce(this.inputOnKeyUp.bind(this), config.search.debounceInputBy);

        // Listeners
        this.nodes.input.addEventListener("keyup", this.inputOnKeyUpDebounced);
        this.nodes.input.addEventListener("focus", this.inputOnFocus.bind(this));
        this.nodes.input.addEventListener("focusout", this.inputOnFocusout.bind(this));
        this.nodes.form.addEventListener("submit", this.formOnSubmit.bind(this));

        this.nodes.clearHistory.addEventListener("click", this.clearHistoryOnClick.bind(this));
      }

      // Init
      connectedCallback() {
        this.assignNodes();
        this.setModalState("default");
        this.setInputState("default");

        this.renderHistory();
        this.listenForEvents();
      }
    }

    /* Search Query Results */
    class Sqr extends HTMLElement {
      constructor() {
        super();
      }

      fetchContent(inject) {
        if (this.isFetching) return;
        this.isFetching = true;

        // Configure Search Params
        var searchParams = new URLSearchParams();
        searchParams.set("view", "modal");
        searchParams.set("type", "product");
        searchParams.set("limit", "4");

        // Sebd request
        WDN.Request.Get({
          url: Shopify.routes.root + "search?q=" + this.query + "&" + searchParams.toString(),
          onSuccess: function (res) {
            // Assign content
            this.content = res;
            // Insert
            if (inject) this.productContainer.innerHTML = this.content;
            // Set state to false
            this.isFetching = false;
          }.bind(this),
          onError: function () {
            // Set state to false
            this.isFetching = false;
          }.bind(this),
        });
      }

      onMouseOver() {
        if (this.content) {
          this.productContainer.innerHTML = this.content;
        } else {
          this.fetchContent(true);
        }
      }

      bind() {
        this.onMouseOverBound = this.onMouseOver.bind(this);

        // Listen for mouse over
        this.addEventListener("mouseenter", this.onMouseOverBound);
      }

      unbind() {
        this.removeEventListener("mouseenter", this.onMouseOverBound);
      }

      preFetch() {
        // Pre-fetch logic (Desktop only)
        if (window.innerWidth < 900) return;

        // Delay fetch so we don't send all requests at once
        // 300ms + (50ms * [index])
        var prefetchDelay = 300 + 80 * (this.index || 1);

        this.prefetchTimeout = setTimeout(
          function () {
            if (!this.content) this.fetchContent();
          }.bind(this),
          prefetchDelay
        );
      }

      // Init
      connectedCallback() {
        // Get query
        this.query = encodeURIComponent(this.getAttribute("data-query")).replaceAll(" ", "+");
        this.index = parseInt(this.getAttribute("data-index"));
        this.searchElement = document.querySelector("search-element");

        // Set up initial value
        this.content = false;
        // Assign output container
        this.productContainer = document.querySelector("[data-search-container='products']");
        // Listen for events
        this.bind();

        // Prefetch
        this.preFetch();
      }

      disconnectedCallback() {
        // Clear pre-fetch timeout
        if (this.prefetchTimeout) clearTimeout(this.prefetchTimeout);

        // Unbind listeners when component removed from the DOM
        this.unbind();
      }
    }

    /* Product Card */
    class SearchProductCard extends HTMLElement {
      constructor() {
        super();
      }

      onQuickshopFetch(res) {
        this.container.innerHTML = res;
        this.setAttribute("data-quickshop-rendered", "true");
      }

      onMouseOver() {
        WDN.Request.Get({
          url: Shopify.routes.root + "products/" + this.handle + "?section_id=async-search-quickshop",
          onSuccess: this.onQuickshopFetch.bind(this),
        });

        this.unbind();
      }

      bind() {
        this.onMouseOverBound = this.onMouseOver.bind(this);

        // Listen for mouse over
        this.addEventListener("mouseenter", this.onMouseOverBound);
      }

      unbind() {
        this.removeEventListener("mouseenter", this.onMouseOverBound);
      }

      // Init
      connectedCallback() {
        this.container = this.querySelector("[data-search-quickshop-container]");
        this.handle = this.getAttribute("data-handle");
        this.bind();
      }
    }

    // Define custom element
    customElements.define("search-element", Search);
    customElements.define("search-query-recommendation", Sqr);
    customElements.define("search-product-card", SearchProductCard);

    var listenForEvents = function () {
      // Listen for modal open & close - toggle body class 'search-modal--active'
      document.body.addEventListener("overlay:closed", function (e) {
        if (e.detail.id !== "search") return;
        document.body.classList.remove("search-modal--active");
      });

      document.body.addEventListener("overlay:opened", function (e) {
        if (e.detail.id !== "search") return;
        document.body.classList.add("search-modal--active");
      });

      // Listen for click on trigger & focus keyboard
      document.querySelectorAll("wdn-modal-open[data-id='search']").forEach(function (trigger) {
        trigger.addEventListener("click", function (e) {
          // Focus modal input
          document.querySelector("wdn-modal[data-id='search'] [data-search-input]").focus();
        });
      });

      // Listen for mobile menu render
      document.addEventListener("mobilemenu:rendered", function () {
        // Select modal opener in mobile menu
        var modalOpener = document.querySelector("[data-navdrawer-content] wdn-modal-open[data-id='search']");

        if (!modalOpener) return;

        // Add click listener
        modalOpener.addEventListener("click", function (e) {
          // Focus modal input
          document.querySelector("wdn-modal[data-id='search'] [data-search-input]").focus();
        });
      });
    };

    listenForEvents();

    return {
      History,
      Suggestions,
    };
  })();
}

/* Mobile tabs logic  */
(function (d) {
  var parent = d.querySelector("[data-search-phone-stage]");
  var tabs = d.querySelectorAll("[data-search-tab]");
  var searchElement = document.querySelector("search-element");

  if (tabs.length === 0 || !parent) return;
  tabs.forEach((tab) =>
    tab.addEventListener("click", () => {
      var value = tab.getAttribute("data-search-tab");
      if (value.length > 0) parent.setAttribute("data-search-phone-stage", value);
    })
  );

  var setPhoneStage = function (newValue) {
    if (!newValue) return;
    parent.setAttribute("data-search-phone-stage", newValue);
  };

  // Listens for search update
  searchElement.addEventListener("search:updated", function () {
    // Store counts
    var productCount = parseInt(searchElement.getAttribute("data-product-count"));
    var suggestionCount = parseInt(searchElement.getAttribute("data-suggestions-count"));

    // If suggestions not found and product found - switch to product tab
    if (suggestionCount === 0 && productCount > 0) {
      setPhoneStage("products");
      return;
    }
  });
})(document);

// Always save query when landing on search results page
if (document.querySelector(".search-query-terms")) {
  if (
    document.querySelector(".search-query-terms").hasAttribute("data-search-terms") &&
    document.querySelector(".search-query-terms").getAttribute("data-search-terms").length > 0
  ) {
    WDN.Search.History.push(document.querySelector(".search-query-terms").getAttribute("data-search-terms"));
  }
}
